import { render, staticRenderFns } from "./att-review.vue?vue&type=template&id=68e3620c&scoped=true&"
import script from "./att-review.vue?vue&type=script&lang=js&"
export * from "./att-review.vue?vue&type=script&lang=js&"
import style0 from "./att-review.vue?vue&type=style&index=0&id=68e3620c&prod&lang=css&"
import style1 from "./att-review.vue?vue&type=style&index=1&id=68e3620c&prod&scoped=true&lang=css&"
import style2 from "./att-review.vue?vue&type=style&index=2&id=68e3620c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3620c",
  null
  
)

export default component.exports